/**
 * Logo configuration for different countries/languages
 * 
 * Each country has its own Porsche dealer branding:
 * - Slovenia (sl): Porsche Slovenija
 * - Romania (ro): Porsche România / Porsche Interauto
 * - Bulgaria (bg): Porsche Bulgaria
 * 
 * The logo displays "PORSCHE" with the country name below it.
 */

// Base Porsche logo (without country name) - white version for dark backgrounds
import porscheLogoWhite from '../assets/images/porsche-logo-white.png';
// Base Porsche logo - dark version for light backgrounds
import porscheLogo from '../assets/images/porsche-logo.png';

export const logoConfig = {
  sl: {
    logo: porscheLogo,
    logoWhite: porscheLogoWhite,
    countryName: 'SLOVENIJA',
    alt: 'Porsche Slovenija',
  },
  ro: {
    logo: porscheLogo,
    logoWhite: porscheLogoWhite,
    countryName: 'ROMÂNIA',
    alt: 'Porsche România',
  },
  bg: {
    logo: porscheLogo,
    logoWhite: porscheLogoWhite,
    countryName: 'БЪЛГАРИЯ',
    alt: 'Porsche Bulgaria',
  },
  en: {
    logo: porscheLogo,
    logoWhite: porscheLogoWhite,
    countryName: '',
    alt: 'Porsche',
  },
};

/**
 * Get logo configuration for a given language
 * @param {string} language - Language code (sl, ro, bg, en)
 * @param {boolean} white - Whether to use white version (for dark backgrounds)
 * @returns {Object} Logo configuration object with src, alt, and countryName
 */
export const getLogo = (language, white = false) => {
  const config = logoConfig[language] || logoConfig.sl;
  return {
    src: white ? config.logoWhite : config.logo,
    alt: config.alt,
    countryName: config.countryName,
  };
};

export default logoConfig;
